import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {useFetch} from "hooks/useFetch";
import {useStore} from "hooks/useStore";

const TransactionTypeFilter = ({
    value,
    onChange,
    disabled = false,
    showAllOption = true,
    allowClear = true,
    hideTitle = false,
    marginBottom = "20px",
    ...props
}) => {
    const stores = useStore();
    const {t} = useTranslation([]);

    const [transactionTypesLoading, transactionTypes] = useFetch({
        fetchFn: stores.companyStore.transactionTypes.bind(null),
        dependencies: [],
        initialCall: true
    });

    return (
        <React.Fragment>
            {!hideTitle && <h5>İşlem Türü</h5>}
            <SelectField
                data-testid="transactionTypeSelect"
                value={value}
                onChange={onChange}
                disabled={disabled}
                allowClear={allowClear}
                mb={marginBottom}
                {...props}
            >
                {showAllOption && (
                    <SelectField.Option value="all" data-testid="transactionTypeSelect_option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}
                {transactionTypes?.map(transactionType => (
                    <SelectField.Option
                        key={transactionType?.value}
                        value={transactionType?.value}
                        data-testid="transactionTypeSelect_option"
                    >
                        {transactionType?.label}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    );
};

export default TransactionTypeFilter;
